import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface ReferenceEvent {
  name: string;
  date: string;
  created_by: string;
}

const initialState: ReferenceEvent[] = [];

const referencesSlice = createSlice({
  name: 'references',
  initialState,
  reducers: {
    setEvents: (state, action: PayloadAction<ReferenceEvent[]>) => {
      return action.payload;
    },
    clearEvents: (state) => {
      state.length = 0;
    },
  },
});

export const { setEvents, clearEvents } = referencesSlice.actions;
export default referencesSlice.reducer;
